const OrdersPage = () => {
    return (
        <div>
            Orders Page
        </div>
    )
}

export default OrdersPage
